<template>
  <div class="d-flex align-items-center">
    <div class="me-3">
      <profile-image :user="user" :size="100" />
    </div>
    <div>
      <h1>{{ user.nickname || '' }}</h1>
      <h2>{{  user.name || '' }}</h2>
      <p class="lead">{{ user.email }}</p>
    </div>
  </div>
</template>

<script setup>

import ProfileImage from "@/app/components/profile/ProfileImage.vue";

import { computed } from "vue";
import { useStore } from "vuex";
const store = useStore();
const user = computed(() => store.state.user)

</script>

<style lang="scss" scoped>


</style>
